export enum PromotionalCodeDiscountType {
  'ABSOLUTE' = 'ABSOLUTE',
  'RELATIVE' = 'RELATIVE',
}
